import HelpList from "../../components/help/HelpList"

export const HelpPage = () => {

    return (
        <HelpList></HelpList>
    )
}